/* me-pp.js — page produit Maxi Échelle : galerie, variantes, qty, ajout panier AJAX, sticky */
(function () {
  function init() {
    var root = document.querySelector('[data-me-pp]');
    if (!root) return;

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-me-variants]').textContent); } catch (e) {}

    // ---- Galerie ----
    var mainImg = root.querySelector('[data-me-main]');
    root.querySelectorAll('[data-me-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-full'); mainImg.srcset = ''; }
        root.querySelectorAll('[data-me-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // ---- Variantes ----
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-me-opt]'));
    var idInput = root.querySelector('[data-me-id]');
    var priceEl = root.querySelector('[data-me-price]');
    var compareEl = root.querySelector('[data-me-compare]');
    var stockEl = root.querySelector('[data-me-stock]');
    var addBtn = root.querySelector('[data-me-add]');
    var stickyPrice = document.querySelector('[data-me-sticky-price]');
    var x4El = root.querySelector('[data-me-x4]');

    function money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function currentOptions() { return optionSelects.map(function (s) { return s.value; }); }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      if (!variants.length) return;
      var v = optionSelects.length ? findVariant(currentOptions()) : variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (x4El) { var n4 = parseInt(x4El.getAttribute('data-n'), 10) || 4; x4El.textContent = money(Math.floor(v.price / n4)); }
      if (compareEl) {
        if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (stockEl) {
        // les libelles viennent du schema de la section, pas du script :
        // une chaine ecrite ici ecraserait silencieusement le reglage.
        stockEl.textContent = v.available
          ? '● ' + (stockEl.getAttribute('data-in') || 'En stock')
          : '○ ' + (stockEl.getAttribute('data-out') || 'Indisponible');
        stockEl.className = 'me-pp__stock ' + (v.available ? 'me-pp__stock--in' : 'me-pp__stock--out');
      }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.classList.toggle('is-disabled', !v.available); }
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    updateVariant();

    // ---- Quantité ----
    root.querySelectorAll('[data-me-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-me-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      wrap.querySelector('[data-me-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    // ---- Ajout au panier AJAX ----
    var form = root.querySelector('[data-me-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.classList.add('is-loading'); }
        var drawer = document.querySelector('cart-drawer');
        var sectionId = drawer && drawer.dataset ? drawer.dataset.sectionId : null;
        var body = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(form.querySelector('[name=quantity]').value, 10) || 1 }] };
        var ajout = root.querySelector('[data-me-addon]');
        if (ajout && ajout.checked && ajout.value) { body.items.push({ id: parseInt(ajout.value, 10), quantity: 1 }); }
        if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (addBtn) { addBtn.classList.remove('is-loading'); }
            var icon = document.querySelector('cart-icon');
            try {
              if (drawer && typeof drawer.renderCartContents === 'function' && cart && cart.sections) {
                drawer.renderCartContents(cart);
              }
              if (icon && typeof icon.ensureCartCountIsCorrect === 'function') { icon.ensureCartCountIsCorrect(); }
              if (drawer && typeof drawer.open === 'function') { drawer.open(); }
              else if (icon && typeof icon.click === 'function') { icon.click(); }
              else { window.location.href = '/cart'; }
            } catch (err) {
              if (icon && typeof icon.click === 'function') { icon.click(); } else { window.location.href = '/cart'; }
            }
          })
          .catch(function () { if (addBtn) { addBtn.classList.remove('is-loading'); } window.location.href = '/cart'; });
      });
    }

    // ---- Sticky mobile (apparaît une fois le CTA principal dépassé) ----
    var sticky = document.querySelector('[data-me-sticky]');
    if (sticky && addBtn) {
      // Visible seulement une fois le bouton principal dépassé (passé au-dessus de l'écran),
      // pas à l'arrivée quand il est encore plus bas. Suivi au défilement plutôt qu'en
      // IntersectionObserver : un saut direct (retour en haut) ne déclenche pas l'observer.
      var stkTick = false;
      var stkMaj = function () {
        stkTick = false;
        sticky.classList.toggle('is-visible', addBtn.getBoundingClientRect().bottom < 0);
      };
      var stkDemande = function () { if (!stkTick) { stkTick = true; requestAnimationFrame(stkMaj); } };
      window.addEventListener('scroll', stkDemande, { passive: true });
      window.addEventListener('resize', stkDemande);
      stkMaj();
      var sBtn = sticky.querySelector('[data-me-sticky-add]');
      if (sBtn) sBtn.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
